import React, { useEffect, useState } from 'react'
import Header from '../component/Header/Header'
import Footer from '../component/Footer/Footer'
// import ContactPageForm from '../component/ContactPageForm/ContactPageForm'
// import ContactForm from '../component/ContactPageFormNew/ContactForm'
import ContactWorkHour from '../component/ContactWorkHour/ContactWorkHour'
import ContactPageForm from '../component/ContacPageNewForm/ContactPageForm'
import FaqSection from '../component/FaqSection/FaqSection'
import { Helmet } from 'react-helmet'

const faqData = [
    {
      "title": "Is it painful?",
      "content": "Some people report a mild warmth or slight tingling sensation during treatment."
    },
   
   

    {
      "title": "How many treatments are needed?",
      "content": "The number of sessions required varies depending on the condition being treated and how an individual responds. Clients typically require several treatments spaced out over a few weeks. We reassess after a few visits and then make adjustments in the frequency and duration of visits."
    },
     
  {
    title: "What is unique about Mobile Laser Therapy?",
    content:
      "We bring Mobile Laser Therapy to you and provide Low Level Laser/ Cold Laser Therapy to you in the comfort of your own home/ office or facility. It is a great service if you are unable to attend a clinic. It may also be more convenient because of your busy schedule. We use the Health Canada approved Bioflex Class 3B Laser system to help you heal faster and reduce pain. Call or email us for more information or to book your first appointment.",
  },

  {
    title: "Does Mobile Laser Therapy work well for tennis and golfers elbow?",
    content:
      "Absolutely- The Bioflex Laser system is effective for both tennis elbow and golfers elbow as well as any other tendon injury in your body. The LA Rams now have Bioflex Laser systems in their facility as the players have found it expedites the healing process and helps them to get back on the field faster. More and more professional sports teams are now incorporating low level laser therapy/cold laser therapy into their physiotherapy methods.",
  },
  {
    title:
      "Why would someone choose to use the services of Mobile laser Therapy?",
    content:
      "People choose our service for convenience, time savings, expertise, assessment and treatment by a Registered Physiotherapist at each visit, faster healing, pain relief, reduced inflammation and trust. The medical grade Class 3B Bioflex Laser that we use is made in Canada, is Health Canada Approved, is non-invasive and has proven results. Please see our client reviews.",
  },
  {
    "title": "Is Bioflex Laser treatment system Health Canada Approved?",
    "content": "Yes, and the Bioflex Professional Laser System that we use for treatments is medical grade and is made in Canada."
  },
 
  {
    title:
      "Is the Laser Therapy treatment provided by Mobile Laser Therapy, covered under benefit plans?",
    content:
      "Yes, Laser Therapy is often covered under Physiotherapy. You should verify with your provider if you have coverage under your plan and find out the coverage amount and guidelines for your specific policy.",
  },

  {
    title: "What regions does Mobile Laser Therapy cover?",
    content: "Etobicoke, Mississauga, Hamilton, Brampton, Oakville, Burlington, Milton, Georgetown, Guelph, Cambridge, Kitchener, Waterloo",
  },
  {
    title: "Does Mobile Laser Therapy also treat competitive athletes?",
    content:
      "Yes- If you have suffered a sports injury we can get you back on the field, court, pitch, rink, bike, dance floor or pool faster. Time is of the essence to get back to competition. Many professional sports teams including the LA Rams use the exact same cold laser system we use. We have helped a number of competitive and recreational athletes return to action quickly. Having the expertise of a Registered Physiotherapist administering the treatment and giving you input and continually assessing your progress is crucial to you recovery. Call us.",
  },
  {
    title: "Why would someone consider Mobile Laser Therapy for Wound Care?",
    content:
      "Low-level laser therapy enhances vascular activity: it speeds the healing process, closes wounds more quickly, and reduces scarring in two ways:<br>- Significantly increases the formation of new capillaries in damaged tissue.<br>- Dilates blood vessels (increases their diameter), thereby improving the flow of blood to damaged tissues",
  },
  {
    title: "Is Bioflex Laser Therapy system helpful for people of all ages?",
    content:
      "Yes, We help people of all ages with faster healing and pain relief with our Bioflex Laser System- We recently helped a 99 year old gentleman relieve the pain he was having in a shoulder and in both knees and he is feeling great. He continues to drive his car and cut his own grass on a weekly basis. His family is thrilled as they live out of town and it gives them peace of mind that he can continue to function in his own home. We currently have a number of high level and recreational athletes who sustained injuries over the summer at sports tournaments or during training and need to get healthy for their upcoming fall sports. Whether it be hockey, rugby, football, baseball, tennis, pickleball, volleyball, golf, dance, swimming, track and field (and the list goes on), we can help.",
  },
  {
    title:
      "Why would someone choose to use the services of Mobile laser Therapy?",
    content:
      "People choose our service for convenience, time savings, expertise, assessment and treatment by a Registered Physiotherapist at each visit, faster healing, pain relief, reduced inflammation and trust. The medical grade Class 3B Bioflex Laser that we use is made in Canada, is Health Canada Approved, is non-invasive and has proven results. Please see our client reviews.",
  },

  {
    "title": "Are there any side effects?",
    "content": "Cold Laser Therapy is considered very safe with very minimal side effects, although some individuals may experience temporary redness or mild soreness at the treatment site."
  },
 

  // mid
  {
    "title": "How does it work?",
    "content": "Cold Laser Therapy, also known as low-level laser therapy (LLLT), emits low-power light wavelengths that are absorbed by cells, stimulating cellular activity and promoting healing by increasing blood flow and reducing inflammation."
  },

  
  // {
    //   "title": "Can I combine cold laser therapy with other treatments?",
    //   "content": "Yes, cold laser therapy can often be used in conjunction with other therapies like physiotherapy, massage therapy, chiropractic treatments, osteopathic, or acupuncture treatments."
    // },
    
  {
    title: "how long does it take to an ankle treatment?",
    content: "An ankle treatment takes approximately 40 mins.",
  },
  {
    title: "Is Bioflex Laser Therapy also a good option for seniors?",
    content:
      "Mobile Laser Therapy and Bioflex Laser Therapy system is an excellent pain and healing solution for people of all ages and we have had good success treating seniors who live at home and in retirement residences. For those people who do not wish to venture out to a clinic due to traffic, weather conditions or inconvenient transportation options, we will treat you in the comfort of your own home. Bioflex is a great option for those recovering from a fall or surgery. It's a good choice for arthritic or chronic pain relief- Call us!",
  },

  {
    title:
      "Why would someone choose to use the services of Mobile laser Therapy?",
    content:
      "People choose our service for convenience, time savings, expertise, assessment and treatment by a Registered Physiotherapist at each visit, faster healing, pain relief, reduced inflammation and trust. The medical grade Class 3B Bioflex Laser that we use is made in Canada, is Health Canada Approved, is non-invasive and has proven results. Please see our client reviews.",
  },
  {
    title:
      "Does Laser Therapy work well in conjunction with other healthcare disciplines?",
    content:
      "Yes- Laser Therapy works well in conjunction with other healthcare disciplines such as physiotherapy, massage therapy, chiropractic treatments, osteopathic or acupuncture treatments. I have helped many people with Laser Therapy over the years who wanted to fast track their healing and who were also being treated with another healthcare discipline. Laser helps you better tolerate the treatment from other disciplines as your injury is healing.",
  },
  {
    title:
      "Is the Class 3 Bioflex Laser system that you use more expensive and more powerful than the small red light units that you can buy on line?",
    content:
      "Yes- much more powerful than the ones you buy on the internet for home use. It is made in Canada, is medical grade and is Health Canada approved. The probe is near infrared so it penetrates much deeper into the tissue for faster pain relief and healing. The personal units that you buy on the internet do not have the probe and therefore do not penetrate as deeply. Many professional sports teams use the same unit we will bring to your home to administer the treatment.",
  },
 
  {
    title: "Why would someone choose Cold Laser Therapy after surgery?",
    content:
      "You may start Cold Laser Therapy shortly after surgery. it helps reduce inflammation which allows the healing process to begin. It is non-invasive and helps with pain management for those who do not like taking pain medications or would like to reduce their pain medication intake. We come to you so you do not need to leave your home for treatment which is really nice when you are having difficulty with your mobility or cannot or do not wish to go to a clinic. Cold Laser Therapy works well in conjunction with other health care disciplines such as Physiotherapy, Massage Therapy, Chiropractic treatments & Osteopathic treatments. Many people who wish to, fast track their healing do both. Many pro athletes combine Cold Laser Therapy with other health care disciplines.",
  },

 

  {
    title: "Are there any side effects to Laser Therapy?",
    content:
      "There are no known significant side effects to low-level laser therapy. It is non-invasive, painless, and drug-free. Some clients may experience mild warmth or a slight tingling sensation during treatment, but this is rare.",
  },
  {
    title:
      "What areas does Mobile Laser Therapy currently service? And is service provided at the clients residence?",
    content: "",
  },
  {
    title:
      "Does Mobile Laser Therapy help people who live in retirement homes?",
    content:
      "Yes- we are happy to help people living in retirement residences or Long Term homes. In fact the application is perfect for seniors who cannot get to a clinic or would prefer Cold Laser Therapy administered by a registered physiotherapist in the comfort of their own suite. Great for post surgical pain relief and expedited healing, arthritis, fractures, ligaments sprains, bruises, tendonitis, back pain, shoulders or healing an incision or wound faster and much much more.",
  },
  {
    title:
      "How long after surgery is it recommended to start treatments to reduce inflammation and pain and progress the healing process?",
    content:
      "It is recommended that once your surgeon allows the tenser bandage (if you have one) to be removed that you may start Bioflex Laser Therapy treatments. The sooner the better as you want to reduce inflammation. If the tenser bandage is removed we can laser around the bandages covering the wound as the light will be still be absorbed in the cells. The reduction of the inflammation after surgery is key in order to allow the healing process to continue.",
  },
];


function Contact() {
  const [bgImg,setBgImg]  = useState('/images/creatives/contact-hero-bg.png')
  
      useEffect(()=>{
        if(window.innerWidth <= 992)
        {
          setBgImg("/images/creatives/contact-hero-bg-mob.png")
        }
      },[])
  return (
    <div>
      <Helmet>
        <title>
        Contact Us | Mobile Laser Therapy
        </title>
        <meta name="keywords" 
        content=""
        ></meta>
        <link
          rel="canonical"
          href="https://www.mobilelasertherapy.ca/contact"
        />
        <meta
          name="description"
          content="Get in touch with Mobile Laser Therapy in Toronto for non-invasive, drug-free laser treatments. Contact us today to schedule your appointment and start your journey to pain relief and recovery."
        ></meta>
      </Helmet>
        <div style={{backgroundColor:"#F4FEFD"}}>
            <Header/>
        </div>
        <div style={{position:"relative",zIndex:"-1"}}>
            <img src={bgImg} alt='contact page hero' style={{width:"100%"}}/>
            <div className='container About-hero-bg-resp'>
                {/* <h3 className='hero-section-heading text-center' style={{color:'white',textShadow:"1px 0 white"}}>Contact Us</h3> */}
                <h3 className='hero-section-heading text-center' style={{color:'white',textShadow:"1px 0 white"}}>Contact us/ Frequently Asked Questions</h3>
            </div>
        </div>

        {/* <ContactWorkHour/> */}

        <ContactPageForm/>

        <FaqSection
        heading={"Frequently Asked Questions"}
        para="Can't find the answer you're looking for? Let's Connect."
          faqData={faqData}
        />

        <Footer 
        newsletterSection={false}
        />
    </div>
  )
}

export default Contact